var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c(
        "b-field",
        { staticClass: "file is-fullwidth" },
        [
          _c(
            "b-upload",
            {
              attrs: { accept: _vm.getAccept(_vm.subunidad.formatos) },
              model: {
                value: _vm.file,
                callback: function ($$v) {
                  _vm.file = $$v
                },
                expression: "file",
              },
            },
            [
              _c("a", { staticClass: "button is-primary" }, [
                _c("i", { staticClass: "fas fa-upload" }),
                _vm._v(" \n        "),
                _c("span", [_vm._v("Seleccionar archivo")]),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.file
            ? _c("span", { staticClass: "file-name" }, [
                _vm._v(_vm._s(_vm.file.name)),
              ])
            : _c("span", { staticClass: "file-name" }, [
                _c("i", [_vm._v("Haga clic para seleccionar un archivo")]),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", [
          _c("b", [_vm._v("Subunidad:")]),
          _vm._v("\n      " + _vm._s(_vm.subunidad.nombre) + " -\n      "),
          _c("b", [_vm._v("Formatos:")]),
          _vm._v(
            "\n      " + _vm._s(_vm.subunidad.formatos.join(",")) + " -\n      "
          ),
          _c("b", [_vm._v("Colección:")]),
          _vm._v(
            "\n      " + _vm._s(_vm.subunidad.multiple ? "Si" : "No") + "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.file
        ? _c(
            "button",
            {
              staticClass: "button is-success is-fullwidth",
              on: { click: _vm.submit },
            },
            [
              _c("i", { staticClass: "fas fa-paper-plane" }),
              _vm._v(" Enviar archivo\n  "),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }